import React, {Component} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronDown, faChevronRight} from '@fortawesome/pro-solid-svg-icons';
import menu from '../../assets/images/menu.png';
import {connect} from "react-redux";
import {withRouter} from 'react-router';

class Menu extends Component {
    openLink = (e, item) => {
        e.preventDefault();
        e.stopPropagation();

        const {router} = this.props;

        if (item.data.link) {
            if(item.data.link.contentId) {
                router.push(`/page/${item.data.link.contentId}`);
            } else {
                if (item.data.linkTarget) {
                    window.open(item.data.link.url, '_blank');
                } else {
                    window.location.href = item.data.link.url;
                }
            }
        }
    };

    renderChildren = (children) => {
        if(children.length > 0) {
            return (
                <ul>
                    {children.map(item => {
                        if (item.status === 1) {
                            return (
                                <li key={item.data.title} onClick={(e) => this.openLink(e, item)}>
                                    <span>{item.data.title} {item.children.length > 0 && <FontAwesomeIcon icon={faChevronRight}/>}</span>
                                    {this.renderChildren(item.children)}
                                </li>
                            );
                        }

                        return null;
                    })}
                </ul>
            );
        }

        return null;
    };

    renderMegaMenu = (item) => {
        if (item.status === 1) {
            return (
                <div className="mega-menu">
                    <div className="image">
                        <img src={menu} alt={item.data.title}/>
                    </div>
                    <div className="sub-menu">
                        {this.renderChildren(item.children)}
                    </div>
                </div>
            );
        }
    };

    renderMenuTopLevelItem = (item) => {
        const {router} = this.props;
        const hasChildren = item.children.length > 0;

        if (item.data && item.status === 1) {
            return (
                <li
                    key={item.id}
                    onClick={(e) => this.openLink(e, item)}
                    className={`
                        ${hasChildren > 0 ? 'has-children' : 'no-children'}
                        ${parseInt(router.params.page, 10) === (item.data.link && item.data.link.contentId) ? 'active' : ''}
                    `}
                >
                    <span>{item.data.title} {hasChildren && <FontAwesomeIcon icon={faChevronDown}/>}</span>
                    {hasChildren && this.renderMegaMenu(item)}
                </li>
            );
        }
    };

    render() {
        const {item} = this.props;

        return (
            <div className="menu">
                <ul>
                    {item.data.map(item => this.renderMenuTopLevelItem(item))}
                </ul>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.language
    };
};

export default withRouter(connect(mapStateToProps)(Menu));



// WEBPACK FOOTER //
// ./src/frontend/components/UI/Menu.js